module.exports = __webpack_public_path__ + "img/networdBlack.476deceb.png";